<template>
    <el-dialog title="高级检索" width="60%" :close-on-click-modal="false" append-to-body @close="cancel()"
               :visible.sync="visible" v-if="visible">
        <el-form size="small" :model="inputForm" :inline="true" ref="inputForm" label-width="0px">
            <div class="m_b1" v-if="inputForm.whereList.length">筛选条件</div>
            <div v-for="(item, index) in inputForm.whereList" :key="index">
                <el-form-item :prop="`whereList.${index}.method`" v-if="methodType">
                    <el-select v-model="item.method" placeholder="请选择" class="methodSel">
                        <el-option v-for="(e, i) in  $dictUtils.getDictList('conditionApproach')" :key="i"
                                   :label="e.label"
                                   :value="e.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :prop="`whereList.${index}.key`"
                              :rules="[{required: true, message: '筛选的字段名不能为空', trigger: 'change'}]">
                    <el-select v-model="item.key" placeholder="请选择要筛选的字段名" filterable @change="archivesChange(item)">
                        <el-option v-for="c in config" :key="item.basicCode" :label="c.basicName"
                                   :value="c.basicCode" :disabled="c.disabled == '0' ? true : false"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :prop="`whereList.${index}.basicTypeMethodCode`"
                              :rules="[{required: true, whitespace: true, message: '筛选条件不能为空', trigger: 'change'}]"
                              v-if="item.key">
                    <el-select v-model="item.basicTypeMethodCode" placeholder="请选择">
                        <el-option
                                :key="v.value"
                                :label="v.label"
                                :value="v.value"
                                v-for="v in getMethodCode(item)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :prop="`whereList.${index}.value`"
                              :rules="[{required: true, message: '筛选值不能为空', trigger: 'change'}]"
                              v-if="item.basicTypeMethodCode && item.basicTypeMethodCode != '=null' && item.basicTypeMethodCode != '!=null'">
                    <!--单行文本-->
                    <el-input v-model.trim="item.value" placeholder="请输入"
                              :maxlength="item.basicAssemblyId == 1 ? 200: 2000"
                              clearable
                              v-if="item.basicAssemblyId == 1 || item.basicAssemblyId == 2"></el-input>
                    <!--数字-->
                    <el-input v-model.trim="item.value" placeholder="请输入" clearable maxlength="8"
                              @input="(v)=>(item.value=v.replace(/[^\d-]/g,''))" v-if="item.basicAssemblyId == 12"></el-input>
                    <!--下拉单选、单选框组、下拉多选、多选框组-->
                    <el-select v-model="item.value"
                               :multiple="item.basicAssemblyId == 6 || item.basicAssemblyId == 7"
                               placeholder="请选择" clearable
                               v-if="item.basicAssemblyId == 4 || item.basicAssemblyId == 5 || item.basicAssemblyId == 6 || item.basicAssemblyId == 7 || item.basicAssemblyId == 10">
                        <el-option v-for="(v,i) in item.basicRangeList" :key="i"
                                   :label="v.basicRange"
                                   :value="v.basicRange"></el-option>
                    </el-select>
                    <!--时间-->
                    <el-time-picker v-model="item.value" placeholder="请选择"
                                    value-format="yyyy-MM-dd HH:mm:ss" format="HH:mm:ss"
                                    v-if="item.basicAssemblyId == 8"></el-time-picker>
                    <!--日期-->
                    <el-date-picker class="w100i"
                                    v-model="item.value" value-format="yyyy-MM-dd HH:mm:ss"
                                    :format="item.metadataBasicDataRuleVo ? item.metadataBasicDataRuleVo.ruleDateFormat : 'yyyy-MM-dd HH:mm:ss'"
                                    :type="setDatePickerType(item)"
                                    clearable placeholder="请选择"
                                    v-if="item.basicAssemblyId == 9"></el-date-picker>
                </el-form-item>
                <div class="el-icon-error pointer" @click="del(index)"></div>
            </div>
            <el-button type="text" class="addCondition" @click="addCondition()">+ 添加筛选条件</el-button>

        </el-form>
        <div slot="footer">
            <el-button size="small" @click="cancel()">取消</el-button>
            <el-button size="small" type="primary" @click="confirm()" v-noMoreClick>确定</el-button>
        </div>
    </el-dialog>
</template>

<script>

    export default {
        data() {
            return {
                visible: false,
                basicDataId: '',
                inputForm: {
                    whereList: [],
                },
                config: [],
                methodType: '',
            }
        },
        methods: {
            // type：是否显示且或
            init(basicDataId, advancedList, type) {
                this.basicDataId = basicDataId
                this.inputForm.whereList = advancedList
                this.methodType = type
                this.visible = true
                if (!advancedList.length) {
                    this.addCondition()
                }
                this.getAllField()
            },
            // 获取全部字段
            getAllField() {
                this.$axios(this.api.metadata.getTableAndWhere, {basicDataId: this.basicDataId}).then(data => {
                    if (data.status) {
                        this.config = data.data
                    }
                })
            },
            // 选择字段名
            archivesChange(val) {
                let item = this.config.filter(v => v.basicCode == val.key)[0]
                this.$set(val, 'basicAssemblyId', item.basicAssemblyId)
                this.$set(val, 'basicRangeList', item.basicRangeList)
                this.$set(val, 'assemblyType', item.assemblyType)
                this.$set(val, 'metadataBasicDataRuleVo', item.metadataBasicDataRuleVo)
                this.$set(val, 'value', null)
            },
            // 添加筛选条件
            addCondition() {
                this.inputForm.whereList.push({
                    key: '',
                    basicTypeMethodCode: "",
                    assemblyType: "",
                    value: '',
                    method: 'and',
                })
            },
            // 删除筛选条件
            del(index) {
                if (this.inputForm.whereList.length == 1) {
                    this.$message.warning('至少保留一个筛选项')
                    return
                }
                this.$confirm(`确定删除所选项吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.inputForm.whereList.splice(index, 1);
                })
            },
            // 取消
            cancel() {
                this.$emit("getDataList", {whereList: [], advancedList: []})
                this.visible = false
            },
            // 确定
            confirm() {
                this.$refs['inputForm'].validate((valid) => {
                    if (valid) {
                        let advancedList = JSON.parse(JSON.stringify(this.inputForm.whereList))
                        let whereList = []
                        advancedList.map(item => {
                            if (item.basicAssemblyId == 6 || item.basicAssemblyId == 7) {
                                item.value.map(v => {
                                    whereList.push(this.returnWhere(v, item.method, item.key, item.basicTypeMethodCode, item.assemblyType))
                                })
                            }else {
                                whereList.push(this.returnWhere(item.value, item.method, item.key, item.basicTypeMethodCode, item.assemblyType))
                            }
                        })
                        this.$nextTick(() => {
                            this.$emit("getDataList", {whereList, advancedList})
                            this.visible = false
                        })
                    }
                })
            },
            returnWhere(value, method, key, basicTypeMethodCode, assemblyType) {
                return {value, method, key, basicTypeMethodCode, assemblyType}
            },
            // 获取条件字典
            getMethodCode(item) {
                let condition = this.$dictUtils.getDictList('condition')
                let opt = condition.filter(v => v.value != '>=' && v.value != '<=')
                if(item.basicAssemblyId == '8' || item.basicAssemblyId == '9' || item.basicAssemblyId == '12') {
                    opt = condition.filter(v => v.value != '%' && v.value != '!%')
                }
                return opt
            }
        },
    }
</script>

<style scoped>
    .el-icon-error {
        vertical-align: sub;
    }

    .valItem {
        width: 210px !important;
    }

    .methodSel {
        width: 60px !important;
    }
</style>
